import { useEffect, useRef } from "react";
import { saveJourneyLocal } from "../storage/journeyStorage";
import { getJourneyFramingValidation } from "../storage/actionItemModel";

const AUTOSAVE_DELAY = 30000;

const useAutosave = (authState, state, dispatch) => {
  const lastSavedState = useRef(null);
  const timeoutRef = useRef(null);
  const journeyMetaId = state?.journeyMeta?.id;
  const journeyMetaData = state?.journeyMeta?.data;

  useEffect(() => {
    lastSavedState.current = journeyMetaData ?? null;
  }, [journeyMetaData, journeyMetaId]);

  useEffect(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    const hasLocalRecord = Boolean(state?.journeyMeta?.id);
    const hasDataChanged = JSON.stringify(lastSavedState.current) !== JSON.stringify(state.userDocs);
    const hasFramingErrors = Object.keys(getJourneyFramingValidation(state.userDocs, { requireRequiredFields: false })).length > 0;

    if (!hasLocalRecord || state.disableAutoSave || !hasDataChanged || hasFramingErrors) {
      return;
    }

    timeoutRef.current = setTimeout(async () => {
      try {
        // This debounce intentionally saves only the IndexedDB working copy.
        // Firestore is never updated by autosave; cloud overwrite remains an explicit user action.
        const savedRecord = await saveJourneyLocal(state.journeyMeta, state.userDocs);
        lastSavedState.current = savedRecord.data;
        dispatch({
          type: 'LOCAL_SAVE_COMPLETE',
          payload: {
            journeyMeta: savedRecord,
            storageStatus: 'Saved locally',
          },
        });
      } catch (error) {
        console.error('Local autosave failed', error);
        dispatch({
          type: 'SHOW_ALERT',
          payload: { message: 'Local autosave failed. Try Save locally before closing the browser.' },
        });
      }
    }, AUTOSAVE_DELAY);

    return () => clearTimeout(timeoutRef.current);
  }, [state.userDocs, state.disableAutoSave, state.journeyMeta, authState, dispatch]);
};

export default useAutosave;
